import { useEffect, useState } from "react";
import ContainerDashboard from "../../components/layouts/ContainerDashboard"
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../Config";
import AuditTable from "./LogsTable";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const AuditLogs = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 10, totalPages: 0 })
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [action, setAction] = useState("All")
    const [range, setRange] = useState('')
    const [apiDates, setApiDates] = useState(null)

    const navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0)
        document.title = "Audit Logs | Mindora"
    }, [])

    useEffect(() => {
        fetchLogs()
    }, [page, limit, apiDates, action])

    const fetchLogs = () => {
        setLoading(true)
        const params = { page, limit }
        if (apiDates?.[0] && apiDates?.[1]) {
            params.startDate = apiDates[0]
            params.endDate = apiDates[1]
        }
        if (action !== "All") {
            params.action = action
        }
        axiosInstance.get('audit-logs', { params })
            .then(res => {
                setData(res.data.data ?? [])
                setPagination(res.data.pagination ?? { total: 0, page, limit, totalPages: 0 })
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false))
    }

    const changePage = (pagecount) => {
        if (pagecount > 0 && pagecount <= pagination.totalPages) {
            setPage(pagecount)
            window.scrollTo(0, 0)
        }
    }

    const filteredData = data.filter(log => {
        if (action !== "All" && log.action?.toLowerCase() !== action.toLowerCase()) return false
        if (range?.[0] && range?.[1]) {
            const logDate = new Date(log.createdAt)
            const start = new Date(range[0])
            const end = new Date(range[1])
            end.setHours(23, 59, 59, 999)
            if (logDate < start || logDate > end) return false
        }
        return true
    })

    return (
        <>
            {loading && <Loader />}
            <ContainerDashboard title="Audit Logs" description="Everything here">
                <section className="ps-dashboards" id="homepages">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-md-12">
                            <div className="p-4 py-5 bg-gradientt rounded-4" style={{ minHeight: '75vh' }}>

                                <div className='d-md-flex justify-content-between align-items-start mb-4'>
                                    <div className="ps-section__search d-flex justify-content-end">
                                        <select className='form-select ms-3 fs-5'
                                            value={action}
                                            onChange={(e) => {
                                                setPage(1)
                                                setAction(e.target.value)
                                            }}
                                            style={{ width: '180px', height: '45px', borderRadius: '8px' }}>
                                            <option value="All">All</option>
                                            <option value="created">Created</option>
                                            <option value="updated">Updated</option>
                                            <option value="deleted">Deleted</option>
                                        </select>

                                        <select className='form-select ms-3 fs-5'
                                            value={limit}
                                            onChange={(e) => {
                                                setPage(1)
                                                setLimit(Number(e.target.value))
                                            }}
                                            style={{ width: '110px', height: '45px', borderRadius: '8px' }}>
                                            <option value="5">Show 5</option>
                                            <option value="10">Show 10</option>
                                            <option value="20">Show 20</option>
                                            <option value="30">Show 30</option>
                                        </select>

                                        <RangePicker
                                            onChange={(_, dateString) => {
                                                setRange(dateString)
                                                if (dateString?.[0] && dateString?.[1]) {
                                                    setPage(1)
                                                    setApiDates(dateString)
                                                } else if (!dateString?.[0] && !dateString?.[1]) {
                                                    setPage(1)
                                                    setApiDates(null)
                                                }
                                            }}
                                            className="ms-3"
                                            placement="bottom"
                                            style={{ borderRadius: '8px' }}
                                        />
                                    </div>
                                    <div className='text-center mt-3 mt-xl-0'>
                                        <button type="button" onClick={() => navigate(-1)}
                                            className="button ms-3"
                                            style={{ background: '#1a1a2e', color: '#fff', borderRadius: '12px' }}>
                                            <i className='icon-arrow-left me-2'></i>
                                            Back
                                        </button>
                                    </div>
                                </div>

                                <AuditTable data={filteredData} />

                                <div className='d-flex flex-column align-items-end mt-5'>
                                    <p className='mb-4'>Showing {filteredData.length} of {pagination.total} items.</p>
                                    <div className='d-flex justify-content-md-start justify-content-center flex-wrap'>
                                        <div className="bd-number-pagination rounded-2 me-3 mt-2"
                                            onClick={() => changePage(page - 1)}>
                                            <i className='icon-arrow-left'></i>
                                        </div>
                                        {[page - 1, page, page + 1]
                                            .filter(p => p >= 1 && p <= pagination.totalPages)
                                            .map(p => (
                                                <div key={p}
                                                    className={`bd-number-pagination rounded-2 mx-1 pe-1 mt-2 ${page === p ? 'activepage' : ''}`}
                                                    onClick={() => changePage(p)}>
                                                    {p < 10 ? ('0' + p) : p}
                                                </div>
                                            ))}
                                        <div className="bd-number-pagination rounded-2 ms-3 mt-2"
                                            onClick={() => changePage(page + 1)}>
                                            <i className='icon-arrow-right'></i>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </ContainerDashboard>
        </>
    )
}

export default AuditLogs;
